/*!
VueLayers
Web map Vue components with the power of OpenLayers

@package vuelayers
@author Vladimir Vershinin <ghettovoice@gmail.com>
@version 0.10.25
@license MIT
@copyright (c) 2017-2018, Vladimir Vershinin <ghettovoice@gmail.com>
*/
'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var layer = _interopDefault(require('./layer'));
var stylesContainer = _interopDefault(require('./styles-container'));
var mergeDescriptors = _interopDefault(require('../util/multi-merge-descriptors'));

var props = {
  /**
   * When set to `true`, feature batches will be recreated during animations.
   * @type {boolean}
   * @default false
   */
  updateWhileAnimating: Boolean,
  /**
   * When set to `true`, feature batches will be recreated during interactions.
   * @type {boolean}
   * @default false
   */
  updateWhileInteracting: Boolean,
  /**
   * @type {number|undefined}
   */
  renderBuffer: {
    type: Number,
    default: 100
  },
  /**
   * @type {ol.RenderOrderFunction|undefined}
   */
  renderOrder: Function,
  /**
   * @type {boolean}
   */
  declutter: Boolean
};

var methods = {
  /**
   * @return {Promise<Vue<ol.layer.Layer>>}
   * @protected
   */
  init: function init() {
    return layer.methods.init.call(this);
  },

  /**
   * @return {void|Promise<void>}
   * @protected
   */
  deinit: function deinit() {
    return layer.methods.deinit.call(this);
  },

  /**
   * @returns {Object}
   * @protected
   */
  getServices: function getServices() {
    return mergeDescriptors(layer.methods.getServices.call(this), stylesContainer.methods.getServices.call(this));
  },

  /**
   * @return {ol.layer.Vector|undefined}
   * @protected
   */
  getStyleTarget: function getStyleTarget() {
    return this.$layer;
  },

  /**
   * @return {void}
   * @protected
   */
  mount: function mount() {
    layer.methods.mount.call(this);
  },

  /**
   * @return {void}
   * @protected
   */
  unmount: function unmount() {
    layer.methods.unmount.call(this);
  }
};

var vectorLayer = {
  mixins: [layer, stylesContainer],
  props: props,
  methods: methods
};

module.exports = vectorLayer;



//////////////////
// WEBPACK FOOTER
// ./~/vuelayers/lib/mixin/vector-layer.js
// module id = 238
// module chunks = 1